import { render, staticRenderFns } from "./NewSeason.vue?vue&type=template&id=3f7039e5&scoped=true&"
import script from "./NewSeason.vue?vue&type=script&lang=js&"
export * from "./NewSeason.vue?vue&type=script&lang=js&"
import style0 from "./NewSeason.vue?vue&type=style&index=0&id=3f7039e5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f7039e5",
  null
  
)

export default component.exports